<template>
  <TableCell
    v-if="item.isValid"
    :to="item.downloadLink"
    class="pb-profiles-list-column-icons pb-icon-cell"
    center
  >
    <UiIcon
      v-tooltip="{ text: translate('pb2.downloadProfile.label') }"
      class="pb-icon-cell-item"
      icon="download"
    />
  </TableCell>
  <TableCell
    v-else
    :to="item.link"
    class="pb-profiles-list-column-icons pb-icon-cell"
    center
  >
    <UiIcon
      v-tooltip="{ text: translate('pb2.downloadProfile.labelDisabled') }"
      class="pb-icon-cell-item"
      icon="warning"
      color="error"
    />
  </TableCell>
</template>

<script setup>
import TableCell from '@nicolaudie-group/ng-ui-kit/components/Table/TableCell.vue'
import UiIcon from '@nicolaudie-group/ng-ui-kit/components/UiIcon/UiIcon.vue'
import vTooltip from '@nicolaudie-group/ng-ui-kit/directives/vTooltip'
import useTranslate from '@/composables/useTranslate'

const { translate } = useTranslate()

defineProps({
  item: { type: Object, required: true },
})
</script>
